// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__Qu1iB","info":"PatientInfo_info__3YmML"};